import axios from 'axios';

/**
 * Converts a URL to base64 data URL
 * @param {string} url - The URL to convert
 * @returns {Promise<string|null>} - Base64 data URL or null if failed
 */
export const convertUrlToBase64 = async (url, maxRetries = 3, delay = 1000) => {
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      const response = await axios.get(url, {
        responseType: 'arraybuffer'
      });

      const contentType = response.headers['content-type'] || 'image/jpeg';

      // Convert ArrayBuffer to base64 using browser-compatible method
      const uint8Array = new Uint8Array(response.data);
      let binaryString = '';
      for (let i = 0; i < uint8Array.length; i++) {
        binaryString += String.fromCharCode(uint8Array[i]);
      }
      const base64 = btoa(binaryString);

      return `data:${contentType};base64,${base64}`;
    } catch (error) {
      if (attempt === maxRetries) {
        return null;
      }

      // Wait before retrying (S3 eventual consistency)
      await new Promise(resolve => setTimeout(resolve, delay));
      delay *= 2; // Exponential backoff
    }
  }
};